import { FC, useEffect, useState } from "react";

import { getAppConfigs } from "services/appConfigs";
import { getPlaidLink } from "services/users";

import VerificationConfirmation from "./VerificationConfirmation";

const PlaidLinkDialog: FC = () => {
  const [linkToken, setLinkToken] = useState<string>(null);
  const [minimumBalance, setMinimumBalance] = useState<number>();

  useEffect(() => {
    (async () => {
      try {
        const linkToken = await getPlaidLink();
        setLinkToken(linkToken);
      } catch (e) {
        console.error(e);
        alert(e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const minimumBalance = await getAppConfigs([
          "MINIMUM_BALANCE_FOR_VERIFICATION",
        ]);
        setMinimumBalance(
          minimumBalance["MINIMUM_BALANCE_FOR_VERIFICATION"] as number,
        );
      } catch {
        // pass
      }
    })();
  });

  return linkToken && minimumBalance ? (
    <VerificationConfirmation
      linkToken={linkToken}
      minimumBalance={minimumBalance}
    />
  ) : null;
};

export default PlaidLinkDialog;
